/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, borderRadius, elevation, typography } from '@atlaskit/theme';

export const BannerContainer = styled.div`
  padding: 0 ${gridSize() * 6}px ${gridSize() * 2}px;
  margin-top: ${gridSize() * 3}px;
  max-width: ${gridSize() * 67}px;
  border-radius: ${borderRadius()}px;
  position: relative;
  ${elevation.e200()}

  .close-button {
    position: absolute;
    right: ${gridSize() * 2}px;
    top: ${gridSize()}px;
  }

  & > span {
    &:first-child {
      position: absolute;
      top: ${gridSize() * 1.5}px;
      left: ${gridSize() * 2}px;
    }
  }
`;

export const Title = styled.h4`
  display: inline-block;
  ${typography.h400() as any};
`;

export const Description = styled.div`
  padding: ${gridSize() * 2}px 0;
`;
